import Cookies from 'js-cookie';

export const BANNER_SHOW = 'banner_show';

export const LMS_TOKEN = 'lmsToken';
export const LMS_COURSE_ID = 'lmsCourseId';
export const LMS_MODULE_ID = 'lmsModuleId';
export const LMS_CHAPTER_ID = 'lmsChapterId';
export const LMS_COURSE_NAME = 'lmsCourseName';
export const LMS_CHAPTER_NAME = 'lmsChapterName';
export const LMS_MODULE_NAME = 'lmsModuleName';
export const IS_POST_MODULE_ASSESSMENT_AVAILABLE = 'isPostModuleAssessmentAvailable';
export const IS_COURSE_POST_ASSESSMENT_AVAILABLE = 'isCoursePostAssessmentAvailable';
export const RETAKE_VIEW = 'retakeView';
export const COURSE_MARKS = 'courseMarks';
export const CHAPTER_COMPLETE_PERCENTAGE = 'chapterCompletePercentage';
export const ASSESSMENT_ALLOWED = 'ASSESSMENT_ALLOWED';
export const FEEDBACK_ALLOWED = 'FEEDBACK_ALLOWED';
export const IS_RETAKE_ATTEMPT = 'IsRetakeAttempt';
export const POST_ASSESSMENT = 'postAssessment';
export const POST_CHAPTER_ASSESSMENT = 'postChapterAssessment';


const clearBanner = () => Cookies.remove(BANNER_SHOW);  

const clearAllCookies = () => {
    clearBanner();
};

const setBanner = (contentValue) => {
    const millisecondsInOneDay = 24 * 60 * 60 * 1000;

    if (!contentValue) {
        return;
    }

    Cookies.set(BANNER_SHOW, contentValue);

    setTimeout(clearAllCookies, millisecondsInOneDay);
};

const getBanner = () => Cookies.get(BANNER_SHOW);

export {
    setBanner,
    getBanner,
    clearBanner
};
